export default __webpack_public_path__ + "static/NeedsSection_uk-adb4e1919098f383f6d3ed8846b10865.png";